import React from "react";
import { MessageSquare, Compass, Inbox, Send } from "lucide-react";

const benefits = [
  {
    icon: MessageSquare,
    title: "Vragen beantwoorden",
    text: "Geeft direct antwoord op veelgestelde vragen op basis van uw aanbod.",
  },
  {
    icon: Compass,
    title: "Bezoekers begeleiden",
    text: "Stelt slimme vervolgvragen en leidt bezoekers naar de juiste keuze.",
  },
  {
    icon: Inbox,
    title: "Aanvragen verzamelen",
    text: "Vraagt contactgegevens wanneer iemand interesse toont.",
  },
  {
    icon: Send,
    title: "Doorsturen",
    text: "Stuurt aanvragen overzichtelijk naar uw inbox.",
  },
];

export const SolutionSection = () => {
  return (
    <section className="relative py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.22em] font-mono-display text-[#00FFB7]">
            De oplossing
          </span>
          <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-[42px] tracking-tight leading-[1.1]">
            Een digitale assistent die bezoekers{" "}
            <span className="text-gradient-neon">opvangt vóór ze afhaken</span>
          </h2>
          <p className="mt-5 text-[#A7A7A7] text-base md:text-[17px] leading-relaxed">
            De chatbot helpt bezoekers op het moment dat ze vragen hebben. Hij geeft
            antwoorden op basis van uw aanbod, stelt slimme vervolgvragen en verzamelt
            contactgegevens wanneer iemand interesse toont.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                data-testid={`solution-card-${i}`}
                className="group relative glass rounded-2xl p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#00FFB7]/30"
              >
                <div
                  className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
                  style={{
                    background:
                      "radial-gradient(circle at 30% 0%, rgba(0,255,183,0.25), transparent 60%)",
                  }}
                />
                <div className="relative">
                  <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-neon glow-soft">
                    <Icon className="h-5 w-5 text-[#0A0A1A]" strokeWidth={2.5} />
                  </div>
                  <h3 className="mt-4 font-display font-semibold text-white text-lg">
                    {b.title}
                  </h3>
                  <p className="mt-1.5 text-[#A7A7A7] text-sm leading-relaxed">
                    {b.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
